export default __webpack_public_path__ + "d10c6fe3da9caf3276bef9ca0dc0573f.png";